import * as React from "react";

import dayjs from "dayjs";
import { useUserContext } from "../../user-provider";
import { useUtilityContext } from "../../utility-provider";
import { LOCAL_CONSTANT } from "../Const";
import { useAppDispatch, useAppSelector } from "../../app/hooks";

import { getAccessToken, getPlanAreaInfo, staffName } from "../Common";
import { getLongPageData } from "../../data/DataManage";
import { getFileMetadata } from "../../utility/storage";
import ApprovalSurveyModal from "../subPage/ApprovalSurvey/ApprovalSurveyModal";
import {
    Box,
    Typography,
    Button,
    Grid,
    TextField,
    TableContainer,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    IconButton,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import {
    setAddSurveyObj,
    setObjCover,
} from "../../features/locationAddSurveySlice";
import { addSurveyData } from "../components/LocationAddSurveyFunc";
import { commonFileDownload } from "../Common";
import { coverData } from "../subPage/Cover/CoverFunction";
import PdfViewer from "../../utility/PdfViewer";
import { encryptQueryParam, decryptQueryParam } from '../../utility/util';
import {
    setAdditionalResearchCoverPdf,
    setAdditionalResearchCoverConfirmedPdf,
    setAdditionalResearchPdf,
} from "../../features/additionalResearchSlice";

const headerCell = {
    backgroundColor: "#D9D9D9",
    fontSize: "12px",
    color: "black",
    borderBottom: "1px solid black",
    fontWeight: "Bold",
};
const rowCell = {
    border: "none",
};

//参照値算出結果のラベル
const labels = [
    { header: "初年度", Name: "reference_value_1" },
    { header: "2年度", Name: "reference_value_2" },
    { header: "3年度", Name: "reference_value_3" },
    { header: "4年度", Name: "reference_value_4" },
    { header: "5年度", Name: "reference_value_5" },
];

interface resultProps {
    props: {};
}
const ApprovalSurvey: React.FC<resultProps> = ({ props }) => {
    const user = useUserContext();
    const dispatch = useAppDispatch();
    const utilityCtx = useUtilityContext();
    const [windowSize, setWindowSize] = React.useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });
    //追加調査を取得
    const objLocationAddSurvey = useAppSelector(
        (state) => state.locationAddSurvey.obj
    );
    //URLパラメータ
    const [planAreaId, setPlanAreaId] = React.useState("");
    const [branch, setBranch] = React.useState("");

    const [approvalModalOpen, setApprovalModalOpen] =
        React.useState<boolean>(false);
    const [userData, setUserData] = React.useState<any>({});
    const [approvalMgrStamp, setApprovalMgrStamp] = React.useState<string>("");
    const [approvalGmStamp, setApprovalGmStamp] = React.useState<string>("");
    const [approvalResearchMgrStamp, setApprovalResearchMgrStamp] =
        React.useState<string>("");
    const [approvalResearchGmStamp, setApprovalResearchGmStamp] =
        React.useState<string>("");
    const [approvalReferenceStaffStamp, setApprovalReferenceStaffStamp] =
        React.useState<string>("");
    const [
        approvalReferenceResearchMgrStamp,
        setApprovalReferenceResearchMgrStamp,
    ] = React.useState<string>("");
    const [
        approvalReferenceResearchGmStamp,
        setApprovalReferenceResearchGmStamp,
    ] = React.useState<string>("");
    const [coverPdfPath, setCoverPdfPath] = React.useState<any>({});
    const [coverConfirmPdfPath, setCoverConfirmPdfPath] = React.useState<any>(
        {}
    );

    const [receptionBook, setReceptionBook] = React.useState<any>([]);
    const [planAreaInfoData, setPlanAreaInfoData] = React.useState<any>();
    const objStorePlanAreaId = useAppSelector(
        (state) => state.longPage.storePlanAreaId
    );

    //プレビュー
    const previewPdfPath = useAppSelector(
        (state) => state.additionalResearch.coverPdfPath
    );
    const previewConfirmedPdfPath = useAppSelector(
        (state) => state.additionalResearch.coverConfirmedPdfPath
    );
    const previewDocumentPdfPath = useAppSelector(
        (state) => state.additionalResearch.pdfPath
    );

    const handleValueChange = (path: any, labelName: string) => {
        if (
            previewPdfPath === path?.fullPath ||
            previewConfirmedPdfPath === path?.fullPath ||
            previewDocumentPdfPath ===
                planAreaId + "/" + branch + path.file_path
        ) {
            if (labelName === "previewPdfPath") {
                dispatch(setAdditionalResearchCoverPdf(""));
            } else if (labelName === "previewConfirmPdfPath") {
                dispatch(setAdditionalResearchCoverConfirmedPdf(""));
            } else if (labelName === "previewDocumentPdfPath") {
                dispatch(setAdditionalResearchPdf(""));
            }
        } else {
            if (labelName === "previewPdfPath") {
                dispatch(setAdditionalResearchCoverPdf(path.fullPath));
            } else if (labelName === "previewConfirmPdfPath") {
                dispatch(setAdditionalResearchCoverConfirmedPdf(path.fullPath));
            } else if (labelName === "previewDocumentPdfPath") {
                dispatch(
                    setAdditionalResearchPdf(
                        planAreaId + "/" + branch + path.file_path
                    )
                );
            }
        }
    };

    //参照値算出結果のテキストフィールド
    const [addSurveyReferenceValue, setAddSurveyReferenceValue] =
        React.useState<any>({
            reference_value_1: "",
            reference_value_2: "",
            reference_value_3: "",
            reference_value_4: "",
            reference_value_5: "",
        });

    React.useEffect(() => {
        //暗号化されたクエリパラメータを復号化
        const search = window.location.search;
        const urlParam = search.substring(1);
        decryptQueryParam(urlParam).then((res) => {
            setPlanAreaId(res[0]);
            setBranch(res[1]);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        }).catch((e:any) => {
            console.log(e);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        });
        function handleResize() {
            // ヘッダーの分を引く
            const tempHeight = window.innerHeight - 48;
            // ハンバーガーメニューの分を引く
            const tempWidth = window.innerWidth - 56;
            setWindowSize({ width: tempWidth, height: tempHeight });
        }

        // 初回ロード時のサイズに基づいてスケーリング
        handleResize();

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    React.useEffect(() => {
        if(planAreaId !== "" && branch !== ""){
            loadApi();
        }
    }, [planAreaId, branch]);

    React.useEffect(() => {
        if (JSON.parse(user.userData || "null") !== null) {
            setUserData(JSON.parse(user.userData));
        }
    }, [user]);

    const loadApi = async () => {
        if (utilityCtx.showSpinner) {
            utilityCtx.showSpinner();
        }
        callApi()
            .then((res: any) => {
                //追加調査
                dispatch(
                    setAddSurveyObj(addSurveyData(res.getLocationAddSurvey))
                );
                // 画像
                const bucket_path =
                    process.env.REACT_APP_GOOGLE_STORAGE +
                    "/" +
                    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET +
                    "/" +
                    planAreaId +
                    "/" +
                    branch;
                const access_token = getAccessToken();

                if (
                    res.getLocationAddSurvey[0].approval_research_mgr_stamp !==
                    ""
                ) {
                    setApprovalResearchMgrStamp(
                        bucket_path +
                            res.getLocationAddSurvey[0]
                                .approval_research_mgr_stamp +
                            access_token
                    );
                }
                if (
                    res.getLocationAddSurvey[0].approval_research_gm_stamp !==
                    ""
                ) {
                    setApprovalResearchGmStamp(
                        bucket_path +
                            res.getLocationAddSurvey[0]
                                .approval_research_gm_stamp +
                            access_token
                    );
                }
                if (res.getLocationAddSurvey[0].approval_mgr_stamp !== "") {
                    setApprovalMgrStamp(
                        bucket_path +
                            res.getLocationAddSurvey[0].approval_mgr_stamp +
                            access_token
                    );
                }
                if (res.getLocationAddSurvey[0].approval_gm_stamp !== "") {
                    setApprovalGmStamp(
                        bucket_path +
                            res.getLocationAddSurvey[0].approval_gm_stamp +
                            access_token
                    );
                }
                if (
                    res.getLocationAddSurvey[0]
                        .approval_reference_staff_stamp !== ""
                ) {
                    setApprovalReferenceStaffStamp(
                        bucket_path +
                            res.getLocationAddSurvey[0]
                                .approval_reference_staff_stamp +
                            access_token
                    );
                }
                if (
                    res.getLocationAddSurvey[0]
                        .approval_reference_research_mgr_stamp !== ""
                ) {
                    setApprovalReferenceResearchMgrStamp(
                        bucket_path +
                            res.getLocationAddSurvey[0]
                                .approval_reference_research_mgr_stamp +
                            access_token
                    );
                }
                if (
                    res.getLocationAddSurvey[0]
                        .approval_reference_research_gm_stamp !== ""
                ) {
                    setApprovalReferenceResearchGmStamp(
                        bucket_path +
                            res.getLocationAddSurvey[0]
                                .approval_reference_research_gm_stamp +
                            access_token
                    );
                }
                setReceptionBook(res.getReceptionBookByIdAndBranch[0]);
                // 表紙
                dispatch(setObjCover(coverData(res.getLocationCover)));
                getPlanAreaInfo(planAreaId, objStorePlanAreaId).then((data) => {
                    setPlanAreaInfoData(data);
                });
            })
            .catch((e) => {
                console.log(e);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            })
            .finally(() => {
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            });
    };

    const callApi = async () => {
        const param: any = [];

        param.push({
            mode: "getLocationAddSurvey",
            plan_area_id: planAreaId,
            branch: branch,
        });
        param.push({
            mode: "getReceptionBookByIdAndBranch",
            plan_area_id: planAreaId,
            branch: branch,
        });
        param.push({
            mode: "getLocationCover",
            plan_area_id: planAreaId,
            branch: branch,
        });

        return await getLongPageData(param);
    };

    const openApprovalModal = () => {
        setApprovalModalOpen(true);
    };

    const closeApprovalModal = () => {
        setApprovalModalOpen(false);
    };

    React.useEffect(() => {
        (async () => {
            if (utilityCtx.showSpinner) {
                utilityCtx.showSpinner();
            }
            try {
                if (objLocationAddSurvey.cover_pdf_path) {
                    await getFileMetadata(
                        "/" +
                            planAreaId +
                            "/" +
                            branch +
                            objLocationAddSurvey.cover_pdf_path
                    ).then((result) => {
                        setCoverPdfPath(result);
                    });
                }
                if (objLocationAddSurvey.cover_confirm_pdf_path) {
                    await getFileMetadata(
                        "/" +
                            planAreaId +
                            "/" +
                            branch +
                            objLocationAddSurvey.cover_confirm_pdf_path
                    ).then((result) => {
                        setCoverConfirmPdfPath(result);
                    });
                }
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            } catch (e) {
                console.log(e);
                if (utilityCtx.hideSpinner) {
                    utilityCtx.hideSpinner();
                }
            }
        })();
    }, [objLocationAddSurvey.cover_excel_user]);

    React.useEffect(() => {
        //ReduxをuseStateに保存
        setAddSurveyReferenceValue({
            ...objLocationAddSurvey,
            reference_value_1: objLocationAddSurvey.reference_value_1,
            reference_value_2: objLocationAddSurvey.reference_value_2,
            reference_value_3: objLocationAddSurvey.reference_value_3,
            reference_value_4: objLocationAddSurvey.reference_value_4,
            reference_value_5: objLocationAddSurvey.reference_value_5,
        });
        const bucket_path =
            process.env.REACT_APP_GOOGLE_STORAGE +
            "/" +
            process.env.REACT_APP_FIREBASE_STORAGE_BUCKET +
            "/" +
            planAreaId +
            "/" +
            branch;
        const access_token = getAccessToken();

        if (objLocationAddSurvey.approval_research_mgr_stamp !== "") {
            setApprovalResearchMgrStamp(
                bucket_path +
                    objLocationAddSurvey.approval_research_mgr_stamp +
                    access_token
            );
        }
        if (objLocationAddSurvey.approval_research_gm_stamp !== "") {
            setApprovalResearchGmStamp(
                bucket_path +
                    objLocationAddSurvey.approval_research_gm_stamp +
                    access_token
            );
        }
        if (objLocationAddSurvey.approval_mgr_stamp !== "") {
            setApprovalMgrStamp(
                bucket_path +
                    objLocationAddSurvey.approval_mgr_stamp +
                    access_token
            );
        }
        if (objLocationAddSurvey.approval_gm_stamp !== "") {
            setApprovalGmStamp(
                bucket_path +
                    objLocationAddSurvey.approval_gm_stamp +
                    access_token
            );
        }
        if (objLocationAddSurvey.approval_reference_staff_stamp !== "") {
            setApprovalReferenceStaffStamp(
                bucket_path +
                    objLocationAddSurvey.approval_reference_staff_stamp +
                    access_token
            );
        }
        if (objLocationAddSurvey.approval_reference_research_mgr_stamp !== "") {
            setApprovalReferenceResearchMgrStamp(
                bucket_path +
                    objLocationAddSurvey.approval_reference_research_mgr_stamp +
                    access_token
            );
        }
        if (objLocationAddSurvey.approval_reference_research_gm_stamp !== "") {
            setApprovalReferenceResearchGmStamp(
                bucket_path +
                    objLocationAddSurvey.approval_reference_research_gm_stamp +
                    access_token
            );
        }
    }, [objLocationAddSurvey]);

    const gotoLocation = () => {
        // 別タブで開く
        const baseUrl = window.location.origin;
        const param = `planAreaId=${planAreaId}&branch=${branch}`;
        encryptQueryParam(param).then((res) => {
            const fullPath = `${baseUrl}/LongPage?` + res;
            window.open(fullPath);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        }).catch((e:any) => {
            console.log(e);
            if (utilityCtx.hideSpinner) {
                utilityCtx.hideSpinner();
            }
        });
    };

    // ファイルDL
    const fileDownload = (data: any, target: string) => {
        let fullPath = "/" + data.fullPath;
        let fileName = "/" + data.name;
        if (target === "descriptionDocument") {
            fullPath = "/" + planAreaId + "/" + branch + data.file_path;
            fileName = data.file_path.substring(5);
        }
        commonFileDownload(fullPath, fileName);
    };

    const showTimeCreated = (data: any) => {
        let timeCreated = "";
        if ("name" in data) {
            timeCreated = dayjs(data?.timeCreated).format(
                "YYYY/MM/DD HH:mm:ss"
            );
        }

        return timeCreated;
    };

    const disabledApproval = () => {
        // 承認画面を開いている時のタスクIDが
        // E001：職種=230　の時、活性化
        // E002：職種=230　の時、活性化
        // E010：職種=230　の時、活性化
        // E012：職種=230　の時、活性化
        // E002：職種=230　の時、活性化
        // E011：職種=230　の時、活性化
        // E013：職種=230　の時、活性化

        // E014：職種=101,102　の時、活性化
        // E003：職種=101,102　の時、活性化
        // E015：職種=101,102　の時、活性化
        let disabled = true;
        if (receptionBook) {
            if (
                [
                    "E001",
                    "E002",
                    "E010",
                    "E012",
                    "E002",
                    "E011",
                    "E013",
                ].includes(receptionBook?.task_id) &&
                ["230"].includes(userData.job_category_code_OA)
            ) {
                disabled = false;
            } else if (
                ["E014", "E003", "E015"].includes(receptionBook?.task_id) &&
                ["101", "102"].includes(userData.job_category_code_OA)
            ) {
                disabled = false;
            }
        }

        return disabled;
    };

    return (
        <Box
            sx={{
                width: windowSize.width + 56,
                height: windowSize.height + 56,
                overflowY: "scroll",
            }}
        >
            <Box sx={{ width: "100%" }}>
                <Box sx={{ padding: "70px 0 20px 40px" }}>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "end",
                            marginRight: "30px",
                        }}
                    >
                        <Button
                            variant="contained"
                            color="success"
                            size="small"
                            sx={{ padding: "10px 20px" }}
                            onClick={gotoLocation}
                        >
                            調査書
                        </Button>
                    </Box>
                    <Box>
                        <h3>追加調査</h3>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography
                            sx={{
                                marginRight: "20px",
                                marginTop: "40px",
                                alignSelf: "flex-start",
                                whiteSpace: "nowrap",
                                fontWeight: "bold",
                            }}
                        >
                            参考値算出結果
                        </Typography>
                        <Grid container alignItems="center" maxWidth="lg">
                            {labels.map((label, index) => (
                                <Grid item xs={2} key={index}>
                                    <Typography
                                        align="center"
                                        sx={{ fontWeight: "bold" }}
                                    >
                                        {label.header}
                                    </Typography>
                                    <TextField
                                        value={
                                            addSurveyReferenceValue[label.Name]
                                        }
                                        inputProps={{
                                            sx: {
                                                textAlign: "center",
                                                backgroundColor: "#FFFCD6",
                                            },
                                        }}
                                        disabled={true}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                        <Box>
                            <Box sx={{ display: "flex" }}>
                                <Box
                                    sx={{
                                        width: "120px",
                                        border: "1px solid #000",
                                        textAlign: "center",
                                    }}
                                >
                                    担当者
                                </Box>
                                <Box
                                    sx={{
                                        width: "120px",
                                        border: "1px solid #000",
                                        textAlign: "center",
                                    }}
                                >
                                    リサーチ Mgr
                                </Box>
                                {approvalReferenceResearchGmStamp != '' && (
                                    <Box
                                        sx={{
                                            width: "120px",
                                            border: "1px solid #000",
                                            textAlign: "center",
                                        }}
                                    >
                                        リサーチ GM
                                    </Box>
                                )}
                            </Box>
                            <Box sx={{ display: "flex" }}>
                                <Box
                                    sx={{
                                        width: "120px",
                                        height: "92px",
                                        border: "1px solid #000",
                                        textAlign: "center",
                                    }}
                                >
                                    <img
                                        src={approvalReferenceStaffStamp}
                                    ></img>
                                </Box>
                                <Box
                                    sx={{
                                        width: "120px",
                                        height: "92px",
                                        border: "1px solid #000",
                                        textAlign: "center",
                                    }}
                                >
                                    <img
                                        src={approvalReferenceResearchMgrStamp}
                                    ></img>
                                </Box>
                                {approvalReferenceResearchGmStamp != '' && (
                                    <Box
                                        sx={{
                                            width: "120px",
                                            height: "92px",
                                            border: "1px solid #000",
                                            textAlign: "center",
                                        }}
                                    >
                                        <img
                                            src={approvalReferenceResearchGmStamp}
                                        ></img>
                                    </Box>
                                )}
                            </Box>
                        </Box>
                    </Box>
                    <Box>
                        <h5>表紙（参考値）</h5>
                    </Box>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sx={{ paddingRight: "40px" }}>
                            <TableContainer
                                sx={{
                                    height: "132px",
                                    width: "100%",
                                    border: "1px solid black",
                                }}
                            >
                                <Table stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={headerCell}>
                                                {LOCAL_CONSTANT.LABEL.FILE_NAME}
                                            </TableCell>
                                            <TableCell sx={headerCell}>
                                                {
                                                    LOCAL_CONSTANT.LABEL
                                                        .UPLOAD_DATE
                                                }
                                            </TableCell>
                                            <TableCell sx={headerCell}>
                                                {LOCAL_CONSTANT.LABEL.UPLOADER}
                                            </TableCell>
                                            <TableCell sx={headerCell}>
                                                PDF
                                            </TableCell>
                                            <TableCell
                                                sx={headerCell}
                                            ></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell
                                                sx={rowCell}
                                                onClick={() =>
                                                    handleValueChange(
                                                        coverPdfPath,
                                                        "previewPdfPath"
                                                    )
                                                }
                                            >
                                                {coverPdfPath?.name}
                                            </TableCell>
                                            <TableCell
                                                sx={rowCell}
                                                onClick={() =>
                                                    handleValueChange(
                                                        coverPdfPath,
                                                        "previewPdfPath"
                                                    )
                                                }
                                            >
                                                {showTimeCreated(coverPdfPath)}
                                            </TableCell>
                                            <TableCell
                                                sx={rowCell}
                                                onClick={() =>
                                                    handleValueChange(
                                                        coverPdfPath,
                                                        "previewPdfPath"
                                                    )
                                                }
                                            >
                                                {staffName(
                                                    objLocationAddSurvey.cover_excel_user
                                                )}
                                            </TableCell>
                                            <TableCell
                                                sx={rowCell}
                                                onClick={() =>
                                                    handleValueChange(
                                                        coverPdfPath,
                                                        "previewPdfPath"
                                                    )
                                                }
                                            >
                                                <IconButton
                                                    sx={{ color: "black" }}
                                                    onClick={() =>
                                                        fileDownload(
                                                            coverPdfPath,
                                                            "cover"
                                                        )
                                                    }
                                                >
                                                    <DownloadIcon />
                                                </IconButton>
                                            </TableCell>
                                            <TableCell sx={rowCell}></TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                    {previewPdfPath !== "" && (
                        <Box sx={{ paddingTop: "30px", width: "98%" }}>
                            <PdfViewer props={{ pdfPath: previewPdfPath }} />
                        </Box>
                    )}
                    <Box sx={{ display: "flex", margin: "20px 0" }}>
                        <h5>表紙（確定値）</h5>
                        <Box>
                            <Box sx={{ display: "flex" }}>
                                <Box
                                    sx={{
                                        width: "120px",
                                        border: "1px solid #000",
                                        textAlign: "center",
                                    }}
                                >
                                    リサーチ Mgr
                                </Box>
                                <Box
                                    sx={{
                                        width: "120px",
                                        border: "1px solid #000",
                                        textAlign: "center",
                                    }}
                                >
                                    リサーチ GM
                                </Box>
                                <Box
                                    sx={{
                                        width: "120px",
                                        border: "1px solid #000",
                                        textAlign: "center",
                                    }}
                                >
                                    リクルート Mgr
                                </Box>
                                <Box
                                    sx={{
                                        width: "120px",
                                        border: "1px solid #000",
                                        textAlign: "center",
                                    }}
                                >
                                    リクルート GM
                                </Box>
                            </Box>
                            <Box sx={{ display: "flex" }}>
                                <Box
                                    sx={{
                                        width: "120px",
                                        height: "92px",
                                        border: "1px solid #000",
                                        textAlign: "center",
                                    }}
                                >
                                    <img src={approvalResearchMgrStamp}></img>
                                </Box>
                                <Box
                                    sx={{
                                        width: "120px",
                                        height: "92px",
                                        border: "1px solid #000",
                                        textAlign: "center",
                                    }}
                                >
                                    <img src={approvalResearchGmStamp}></img>
                                </Box>
                                <Box
                                    sx={{
                                        width: "120px",
                                        height: "92px",
                                        border: "1px solid #000",
                                        textAlign: "center",
                                    }}
                                >
                                    <img src={approvalMgrStamp}></img>
                                </Box>
                                <Box
                                    sx={{
                                        width: "120px",
                                        height: "92px",
                                        border: "1px solid #000",
                                        textAlign: "center",
                                    }}
                                >
                                    <img src={approvalGmStamp}></img>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sx={{ paddingRight: "40px" }}>
                            <TableContainer
                                sx={{
                                    height: "132px",
                                    width: "100%",
                                    border: "1px solid black",
                                }}
                            >
                                <Table stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={headerCell}>
                                                {LOCAL_CONSTANT.LABEL.FILE_NAME}
                                            </TableCell>
                                            <TableCell sx={headerCell}>
                                                {
                                                    LOCAL_CONSTANT.LABEL
                                                        .UPLOAD_DATE
                                                }
                                            </TableCell>
                                            <TableCell sx={headerCell}>
                                                {LOCAL_CONSTANT.LABEL.UPLOADER}
                                            </TableCell>
                                            <TableCell sx={headerCell}>
                                                PDF
                                            </TableCell>
                                            <TableCell
                                                sx={headerCell}
                                            ></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell
                                                sx={rowCell}
                                                onClick={() =>
                                                    handleValueChange(
                                                        coverConfirmPdfPath,
                                                        "previewConfirmPdfPath"
                                                    )
                                                }
                                            >
                                                {coverConfirmPdfPath?.name}
                                            </TableCell>
                                            <TableCell
                                                sx={rowCell}
                                                onClick={() =>
                                                    handleValueChange(
                                                        coverConfirmPdfPath,
                                                        "previewConfirmPdfPath"
                                                    )
                                                }
                                            >
                                                {showTimeCreated(
                                                    coverConfirmPdfPath
                                                )}
                                            </TableCell>
                                            <TableCell
                                                sx={rowCell}
                                                onClick={() =>
                                                    handleValueChange(
                                                        coverConfirmPdfPath,
                                                        "previewConfirmPdfPath"
                                                    )
                                                }
                                            >
                                                {staffName(
                                                    objLocationAddSurvey.cover_confirm_excel_user
                                                )}
                                            </TableCell>
                                            <TableCell
                                                sx={rowCell}
                                                onClick={() =>
                                                    handleValueChange(
                                                        coverConfirmPdfPath,
                                                        "previewConfirmPdfPath"
                                                    )
                                                }
                                            >
                                                <IconButton
                                                    sx={{ color: "black" }}
                                                    onClick={() =>
                                                        fileDownload(
                                                            coverConfirmPdfPath,
                                                            "cover"
                                                        )
                                                    }
                                                >
                                                    <DownloadIcon />
                                                </IconButton>
                                            </TableCell>
                                            <TableCell sx={rowCell}></TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                    {previewConfirmedPdfPath !== "" && (
                        <Box sx={{ paddingTop: "30px", width: "98%" }}>
                            <PdfViewer
                                props={{ pdfPath: previewConfirmedPdfPath }}
                            />
                        </Box>
                    )}
                    <Box>
                        <h5>説明資料</h5>
                    </Box>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sx={{ paddingRight: "40px" }}>
                            <TableContainer
                                sx={{
                                    height: "424px",
                                    width: "100%",
                                    border: "1px solid black",
                                }}
                            >
                                <Table stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={headerCell}>
                                                {LOCAL_CONSTANT.LABEL.FILE_NAME}
                                            </TableCell>
                                            <TableCell sx={headerCell}>
                                                {
                                                    LOCAL_CONSTANT.LABEL
                                                        .UPLOAD_DATE
                                                }
                                            </TableCell>
                                            <TableCell sx={headerCell}>
                                                {LOCAL_CONSTANT.LABEL.UPLOADER}
                                            </TableCell>
                                            <TableCell
                                                sx={headerCell}
                                            ></TableCell>
                                            <TableCell
                                                sx={headerCell}
                                            ></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {objLocationAddSurvey.doc_pdf_path?.map(
                                            (data: any, index: any) => (
                                                <TableRow
                                                    className="tableRow"
                                                    key={index}
                                                >
                                                    <TableCell
                                                        onClick={() =>
                                                            handleValueChange(
                                                                data,
                                                                "previewDocumentPdfPath"
                                                            )
                                                        }
                                                    >
                                                        {data.file_name}
                                                    </TableCell>
                                                    <TableCell
                                                        onClick={() =>
                                                            handleValueChange(
                                                                data,
                                                                "previewDocumentPdfPath"
                                                            )
                                                        }
                                                    >
                                                        {data.upload_date}
                                                    </TableCell>
                                                    <TableCell
                                                        onClick={() =>
                                                            handleValueChange(
                                                                data,
                                                                "previewDocumentPdfPath"
                                                            )
                                                        }
                                                    >
                                                        {staffName(
                                                            data.upload_staff_number
                                                        )}
                                                    </TableCell>
                                                    <TableCell
                                                        onClick={() =>
                                                            handleValueChange(
                                                                data,
                                                                "previewDocumentPdfPath"
                                                            )
                                                        }
                                                    >
                                                        <IconButton
                                                            sx={{
                                                                color: "black",
                                                            }}
                                                            onClick={() =>
                                                                fileDownload(
                                                                    data,
                                                                    "descriptionDocument"
                                                                )
                                                            }
                                                        >
                                                            <DownloadIcon />
                                                        </IconButton>
                                                    </TableCell>
                                                    <TableCell></TableCell>
                                                </TableRow>
                                            )
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                    {previewDocumentPdfPath !== "" && (
                        <Box sx={{ paddingTop: "30px", width: "98%" }}>
                            <PdfViewer
                                props={{
                                    pdfPath: previewDocumentPdfPath,
                                }}
                            />
                        </Box>
                    )}
                </Box>
                <Box
                    sx={{
                        position: "fixed",
                        bottom: "50px",
                        right: "50px",
                        zIndex: 1000,
                    }}
                >
                    <Button
                        variant="contained"
                        color="success"
                        size="small"
                        sx={{ padding: "10px 20px" }}
                        disabled={disabledApproval()}
                        onClick={openApprovalModal}
                    >
                        承認/差戻
                    </Button>
                </Box>
                <ApprovalSurveyModal
                    props={{
                        open: approvalModalOpen,
                        handleModal: closeApprovalModal,
                        planAreaId: planAreaId,
                        branch: branch,
                        userData: userData,
                        receptionBook: receptionBook,
                        planAreaInfoData: planAreaInfoData,
                    }}
                />
            </Box>
        </Box>
    );
};

export default ApprovalSurvey;
